module.exports = __webpack_public_path__ + "static/media/pail-3.ddea2f9e.png";